// extracted by mini-css-extract-plugin
module.exports = {"container":"SortableItem_container__1N5Ve","isDragging":"SortableItem_isDragging__11e55"};